class LocalizationForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
    };

    this.onItemClickHandler = this.onItemClick.bind(this);
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClickHandler));
  }

  disconnectedCallback() {
    this.querySelectorAll('a').forEach(item => item.removeEventListener('click', this.onItemClickHandler));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
